import { CellType, ParameterInputType, ProjectLanguage } from "@hex/common";
import React, { ComponentType } from "react";

import { useProjectContext } from "../../util/projectContext.js";
import { CustomIconProps } from "../icons/createCustomIcon.js";
import {
  ChartCellIcon,
  CodeCellIcon,
  ComponentIcon,
  DbtIcon,
  ExploreIcon,
  FilterCellIcon,
  MapCellIcon,
  MarkdownCellIcon,
  PivotCellIcon,
  PythonLogoIcon,
  SQLCellIcon,
  SectionIcon,
  SingleValueIcon,
  TableCellIcon,
  TextCellIcon,
  WritebackCellIcon,
} from "../icons/CustomIcons.js";
import { getInputIconForType } from "../input/inputIcons.js";

export function cellTypeToIconType(
  cellType: CellType,
  language?: ProjectLanguage,
  inputType?: ParameterInputType,
): ComponentType<CustomIconProps> {
  return (
    {
      [CellType.INPUT]: getInputIconForType(inputType),
      [CellType.MARKDOWN]: MarkdownCellIcon,
      [CellType.CODE]:
        language === ProjectLanguage.R ? CodeCellIcon : PythonLogoIcon,
      [CellType.SQL]: SQLCellIcon,
      [CellType.VEGA_CHART]: ChartCellIcon,
      [CellType.DISPLAY_TABLE]: TableCellIcon,
      [CellType.METRIC]: SingleValueIcon,
      [CellType.CELL_GROUP]: ComponentIcon,
      [CellType.TEXT]: TextCellIcon,
      [CellType.MAP]: MapCellIcon,
      [CellType.WRITEBACK]: WritebackCellIcon,
      [CellType.DBT_METRIC]: DbtIcon,
      [CellType.PIVOT]: PivotCellIcon,
      [CellType.FILTER]: FilterCellIcon,
      [CellType.COMPONENT_IMPORT]: ComponentIcon,
      [CellType.CHART]: ChartCellIcon,
      [CellType.BLOCK]: SQLCellIcon,
      [CellType.EXPLORE]: ExploreIcon,
      [CellType.COLLAPSIBLE]: SectionIcon,
    }[cellType] ?? CodeCellIcon
  );
}

export interface CellTypeIconProps extends CustomIconProps {
  cellType: CellType;
  inputType?: ParameterInputType;
}

export const CellTypeIcon: ComponentType<
  { cellType: CellType; inputType?: ParameterInputType } & CustomIconProps
> = ({
  cellType,
  inputType,
  ...iconProps
}: {
  cellType: CellType;
  inputType?: ParameterInputType;
  language?: ProjectLanguage;
} & CustomIconProps) => {
  const projectContext = useProjectContext({ safe: true });
  const IconToUse = cellTypeToIconType(
    cellType,
    projectContext?.language,
    inputType,
  );
  return <IconToUse {...iconProps} />;
};
